import React from 'react';
import { BadgeAlt, Popover, PopoverContent, PopoverTrigger, } from '@cargomatic/ui';
function renderRow(item) {
    return (React.createElement("div", { className: "flex items-center gap-2" },
        React.createElement("span", { className: "select-text" }, item.value),
        item.badgeLabel && (React.createElement(BadgeAlt, { variant: "outline", className: `whitespace-nowrap shrink-0 ${item.badgeClassName || ''}` }, item.badgeLabel))));
}
/**
 * Renders a list of value + optional badge pairs. First `visibleCount` items
 * appear inline (one per line); the rest collapse into a +X badge that opens
 * a popover with the full list rendered the same way.
 */
export function BadgedOverflowCell({ items, visibleCount = 2, title, }) {
    if (items.length === 0)
        return React.createElement(React.Fragment, null, "\u2014");
    const visible = items.slice(0, visibleCount);
    const hidden = items.slice(visibleCount);
    return (React.createElement("div", { className: "flex flex-col gap-1" },
        visible.map((item) => (React.createElement(React.Fragment, { key: item.key }, renderRow(item)))),
        hidden.length > 0 && (React.createElement(Popover, { modal: false },
            React.createElement(PopoverTrigger, { asChild: true },
                React.createElement("button", { type: "button", className: "self-start cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md", "aria-label": `Show ${hidden.length} more item${hidden.length === 1 ? '' : 's'}`, onClick: (e) => e.stopPropagation() },
                    React.createElement(BadgeAlt, { variant: "secondary", className: "text-xs px-1.5 py-0" },
                        "+",
                        hidden.length))),
            React.createElement(PopoverContent, { className: "w-72 p-2", align: "start", onClick: (e) => e.stopPropagation() },
                React.createElement("p", { className: "text-xs font-semibold text-muted-foreground mb-2" }, title || `All items (${items.length})`),
                React.createElement("ul", { className: "space-y-1 max-h-60 overflow-y-auto" }, items.map((item) => (React.createElement("li", { key: item.key, className: "text-sm" }, renderRow(item))))))))));
}
